import type { ReactNode } from "react";
import { getThemeColors } from "../lib/theme";

interface EmptyStateProps {
  icon: ReactNode;
  message: string;
  isDark: boolean;
  className?: string;
}

export function EmptyState({
  icon,
  message,
  isDark,
  className = "",
}: EmptyStateProps) {
  const theme = getThemeColors(isDark);

  return (
    <div className={`text-center py-16 ${theme.textMuted} ${className}`}>
      <div
        className={`w-16 h-16 mx-auto mb-4 rounded-2xl ${isDark ? "bg-zinc-900" : "bg-gray-100"} flex items-center justify-center`}
      >
        <div
          className={`w-8 h-8 ${isDark ? "text-zinc-600" : "text-gray-400"}`}
        >
          {icon}
        </div>
      </div>
      <p className="text-sm">{message}</p>
    </div>
  );
}
